window.theme = window.theme || {};
window.theme.RS = window.theme.RS || {};

// Event delegation handlers for tabs
function handleTabClick(evt) {
  evt.preventDefault();
  var tabLinks = document.querySelectorAll(".js-customer-tab");
  var tabContents = document.querySelectorAll(".js-customer-tabcontent");
  var tabName = evt.target.getAttribute('data-tab');
  var targetTabPanel = document.querySelector('.js-customer-tabcontent[data-tab="' + tabName + '"]');
  var targetTab = document.querySelector('.js-customer-tab[data-tab="' + tabName + '"]');
  
  handleTabReset(tabLinks, tabContents);
  handleTabSet(targetTab, targetTabPanel);
}

function handleTabKeydown(evt) {
  if (evt.keyCode === 39 || evt.keyCode === 37) {
    evt.preventDefault();
    var tabLinks = document.querySelectorAll(".js-customer-tab");
    var tabContents = document.querySelectorAll(".js-customer-tabcontent");
    var currentIndex = +evt.target.getAttribute('data-index');
    var newFocus = evt.keyCode === 39 ? 'next' : 'previous';
    
    handleTabReset(tabLinks, tabContents);
    handleTabFocus(tabLinks, tabContents, currentIndex, newFocus);
  }
}

function handleTabFocus(tabLinks, tabContents, index, newFocus) {
  var tabLinkNewFocus;

  if (Number.isInteger(index) && tabLinks) {
    if (newFocus === 'next') {
      index + 1 < tabLinks.length ? tabLinkNewFocus = index + 1 : tabLinkNewFocus = 0;
    }
    if (newFocus === 'previous') {
      index > 0 ? tabLinkNewFocus = index - 1 : tabLinkNewFocus = tabLinks.length - 1;
    }
    console.log(index, tabLinkNewFocus)
    handleTabSet(tabLinks[tabLinkNewFocus], tabContents[tabLinkNewFocus])
    tabLinks[tabLinkNewFocus].focus()
    
  }
}

function handleTabReset(tabLinks, tabContents) {
  for (var i=0; i < tabContents.length; i++) {
    tabContents[i].classList.add('hidden');
    tabContents[i].setAttribute('tabindex', -1)
  }
  for (var j=0; j < tabLinks.length; j++) {
    tabLinks[j].classList.remove('is--active');
    tabLinks[j].setAttribute('tabindex', -1)
    tabLinks[j].setAttribute('aria-selected', false)
  }
}

function handleTabSet(targetTab, targetTabPanel) {
  targetTabPanel.classList.remove('hidden');
  targetTabPanel.setAttribute('tabindex', 0)
  targetTab.classList.add('is--active');
  targetTab.setAttribute('tabindex', 0)
  targetTab.setAttribute('aria-selected', true)
}

// Event delegation handler for password toggle
function handlePasswordToggle(evt) {
  evt.preventDefault();
  var toggleButton = document.getElementById('passwordEyeToggle');
  var passwordField = document.getElementById('CustomerLoginPassword');
  
  if (!toggleButton || !passwordField) return;
  
  const passwordSVGs = document.querySelectorAll('#passwordEyeToggle svg');
  const isVisible = passwordSVGs[1] && passwordSVGs[1].classList.contains('hidden');
  
  const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
  passwordField.setAttribute('type', type);
  passwordSVGs.forEach(function(ele){ele.classList.toggle('hidden')});
  toggleButton.setAttribute('aria-label', isVisible ? "hide password" : "show password");
}

// Event delegation handler for new address form toggle
function handleNewAddressToggle(evt) {
  evt.preventDefault();
  var toggleButton = document.querySelectorAll(".js-toggle-newaddress");
  var addressFormWrap = document.getElementById('NewAddressForm');
  
  if (!addressFormWrap) return;

  for (var i=0; i < toggleButton.length; i++) {
    var isExpanded = toggleButton[i].getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
    toggleButton[i].classList.toggle('is--hidden');
    toggleButton[i].setAttribute('aria-expanded', isExpanded);
  }

  addressFormWrap.classList.toggle('hidden');
}

// Event delegation handler for edit address form toggle
function handleEditAddressToggle(evt) {
  evt.preventDefault();
  var toggleButton = document.querySelectorAll(".js-toggle-editaddress");
  var addressId = evt.target.getAttribute('data-address');
  var editFormWrap = document.getElementById('EditAddress_' + addressId);
  
  if (!editFormWrap) return;
  
  for (var i=0; i < toggleButton.length; i++) {
    var isExpanded = toggleButton[i].getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
    toggleButton[i].classList.toggle('is--hidden');
    toggleButton[i].setAttribute('aria-expanded', isExpanded);
  }
  
  editFormWrap.classList.toggle('hidden');
}

function generateStateSelector() {
  var countrySelector = document.getElementById('AddressNewCountry');
  var editCountryList = document.getElementById('EditAddressList');
  
  if(countrySelector) {
    new Shopify.CountryProvinceSelector('AddressNewCountry', 'AddressNewState', {hideElement: 'AddressNewStateContainer'});  
  }
  if(editCountryList) {
    var addressIds = JSON.parse(document.getElementById('EditAddressList').getAttribute('data-address-ids'));

    for(var i=0; i < addressIds.length; i++) {
      var countryId = 'AddressEditCountry-' + addressIds[i];
      var stateId = 'AddressEditState-' + addressIds[i];
      var stateContainerId = 'AddressEditStateContainer-' + addressIds[i];

      new Shopify.CountryProvinceSelector(countryId, stateId, {hideElement: stateContainerId}); 
    }
  }
}

function slideToggle(container) {
  if (!container.classList.contains('accordion--active')) {      
    container.classList.add('accordion--active');
    container.style.height = 'auto';

    var height = container.clientHeight + 'px';
    container.style.height = '0px';
    setTimeout(function () {
      container.style.height = height;
    }, 0);    
  } else {    
    container.style.height = '0px';
    container.addEventListener('transitionend', function() {
      container.classList.remove('accordion--active');
    }, {
      once: true
    });    
  }
}

// Event delegation handler for footer accordion (mobile)
function handleFooterAccordionClick(evt) {
  if (window.screen.width < 768) {
    var target = evt.target.closest('.js-footer-accordion');
    if (!target) return;
    
    var accordionName = target.getAttribute('data-accordion');
    var accordionContent = document.querySelector('.js-footer-content[data-accordion="'+ accordionName +'"]');
    
    if (!accordionContent) return;
    
    target.classList.toggle('accordion--active');
    target.setAttribute('aria-expanded', target.classList.contains('accordion--active'));
    
    if (!evt.target.classList.contains('link')) {
      slideToggle(accordionContent);
    }
  }
}

// Event delegation handler for footer accordion (desktop)
function handleFooterDesktopAccordion(evt) {
  evt.preventDefault();
  var accordionHeading = document.getElementById("footerHeadingDesktop");
  var accordionContent = document.getElementById("footerContentDesktop");
  
  if (!accordionHeading || !accordionContent) return;
  
  var toggleFooterButton = accordionHeading.querySelector('button.showHide');

  accordionHeading.classList.toggle('accordion--active');
  accordionContent.classList.toggle('is--active');
  
  if (toggleFooterButton) {
    var isExpanded = toggleFooterButton.getAttribute('aria-expanded') === "true";
    toggleFooterButton.setAttribute('aria-expanded', !isExpanded);
    toggleFooterButton.setAttribute('aria-label', !isExpanded ? "collapse footer region" : "expand footer region");
  }
}

function updateLoyaltyLionInfo() {
  if(document.querySelector('.template-account')) {
    var currentTierElement = document.querySelector('[data-current-tier-name]');

    var attempt = 1;
    var getLoyaltyLionElement = setInterval(function() {
      if(attempt > 30) {
        clearInterval(getLoyaltyLionElement)
      } else {
        var loyaltyEl = document.querySelector('[data-lion-tier-overview] .lion-tier-box--current .lion-tier-box__title');

        if(loyaltyEl) {
          currentTierElement.innerHTML = loyaltyEl.innerHTML;
          clearInterval(getLoyaltyLionElement);
        }
      }
    }, 500);    
  }
}

// Event delegation handler for skip link
function handleSkipLinkClick(evt) {
  const newFocusEl = document.querySelector('#main');
  if (newFocusEl) {
    newFocusEl.focus();
  }
}

// Event delegation handler for recover password toggle
function handleRecoverPasswordToggle(evt) {
  evt.preventDefault();
  const customerTab = document.getElementById('CustomerTabWrapper');
  const recoverPassword = document.getElementById('CustomerRecoverPassword');
  
  if (customerTab && recoverPassword) {
    customerTab.classList.toggle('is--hidden');
    recoverPassword.classList.toggle('is--hidden');
  }
}

function setTabIndex(el, tabIdx) {
  if (el && tabIdx) {
    el.setAttribute('tabindex', tabIdx)
  }
}

function removeDisabledButtonsFromFlow() {
  //content is injected after DOMContentLoaded event
  setTimeout(() => {
    const buttonEls = document.querySelectorAll('.lion-action-button');

    buttonEls.forEach((el) => {
      const isDisabled = el.classList.contains('lion-action-button--disabled');
      if (isDisabled) {
        setTabIndex(el, -1)
        el.setAttribute('disabled', true)
      } 
    })
  }, 1000);
}

function removeUnnecessaryOkeAttributtes() {
  const targetEls = document.querySelectorAll('.okeReviews-reviewsSummary') || [];
  //content is injected after DOMContentLoaded event. Oke is quite slow in response time.
  setTimeout(() => {
    targetEls.forEach((el) => {
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
    })
  }, 3500);
}

function showSkipToContentLink() {
  const skipLinkEl = document.querySelector('.skip-link');
  if (!skipLinkEl) return;
  
  let observer = null;
  
  const showSkipLink = () => {
    skipLinkEl.classList.remove('hidden');
  };
  
  const cleanupObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };
  
  const checkAndShowSkipLink = () => {
    // Check if page has loaded class
    if (document.body.classList.contains('loaded')) {
      showSkipLink();
      cleanupObserver();
      return true;
    }
    return false;
  };
  
  // Check immediately
  if (checkAndShowSkipLink()) {
    return;
  }
  
  // Observe for changes to body classes
  observer = new MutationObserver(() => {
    checkAndShowSkipLink();
  });
  
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
}

window.theme.RS.Account = (function() {
  const Account = {};
  const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'd34ba21c3c685ebf6b248c2b4015c138';
  const GRAPHQL_URL = window.location.origin + "/api/graphql";
  const ACCESS_TOKEN_KEY = '_rs_a_t';
  const ACCOUNT_UPDATE_SELECTOR = '[data-action="update-customer"]';
  const PW_RECOVER_SELECTOR = '[data-action="recover-password"]';
  const PW_RECOVER_SUBMIT_SELECTOR = '[data-action="submit-recover-password"]';
  const NOTIFICATION_DATASET = 'notificationId';
  const NOTIFICATION_ATTR = 'data-notification';
  const DISABLE_ATTR = 'disabled';
  const EMAIL_NAME_SELECTOR = '[name="customer[email]"]';
  const PW_NAME_SELECTOR = '[name="customer[password]"]';
  const EMAIL_ORIG_NAME_SELECTOR = '[name="customer[original_email]"]';
  const FIRST_NAME_NAME_SELECTOR = '[name="customer[first_name]"]';
  const LAST_NAME_NAME_SELECTOR = '[name="customer[last_name]"]';
  const HIDE_CLASS = 'hidden';
  const INVISIBLE_CLASS = 'rs-invisible';
  const VISIBLE_CLASS = 'rs-visible';
  const DISABLE_CLASS = 'button-disabled';
  const NOTIFICATION_SUCCESS_CLASSES = [
    'text-success',
    'bg-success'
  ];
  const NOTIFICATION_ERROR_CLASSES = [
    'text-error',
    'bg-error'
  ];

  function toggleHideClass(show, elem) {
    if (elem) {
      if (show) {
        elem.classList.add(VISIBLE_CLASS);
        elem.classList.remove(INVISIBLE_CLASS);
      } else {
        elem.classList.add(INVISIBLE_CLASS);
        elem.classList.remove(VISIBLE_CLASS);
      }
    }
  }

  function applyNotificationClasses(isSuccess, elem) {
    if (elem && elem.classList) {
      const removeClass = isSuccess ? NOTIFICATION_ERROR_CLASSES : NOTIFICATION_SUCCESS_CLASSES;
      const addClass = isSuccess ? NOTIFICATION_SUCCESS_CLASSES : NOTIFICATION_ERROR_CLASSES
        elem.classList.remove.apply(elem.classList, removeClass);
        elem.classList.add.apply(elem.classList, addClass);
    }
  }

  Account.TOKEN_SET_EVENT = 'RS:Account:tokenSet';

  Account.createCustomerAccessTokenQuery = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerUserErrors {
        code
        field
        message
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
    }
  }`;

  Account.updateCustomerQuery = `mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
    customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
      customer {
        id
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`;

  Account.fetchToken = function fetchToken(email, pw) {
    if (email && pw) {     
      const tokenSetEvent = new CustomEvent(Account.TOKEN_SET_EVENT); 
      const xhr = new XMLHttpRequest();
      xhr.open("POST", GRAPHQL_URL, false);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", SHOPIFY_STOREFRONT_ACCESS_TOKEN);
    
      const requestBody = {
        query: Account.createCustomerAccessTokenQuery,
        variables: {
          input: {
            email: email,
            password: pw
          }
        }
      };
      
      xhr.onreadystatechange = function() {
        if (this.readyState == 4) {
          let response = {};
          let responseData = {};
          let errors = [];
          try {
            const responseText = JSON.parse(this.responseText || '{}');
            responseData = (responseText && responseText.data ? responseText.data : {}) || {};
            response = responseData && responseData.customerAccessTokenCreate ? responseData.customerAccessTokenCreate : {};
          } catch (error) {
            console.log('RS:Notification: JSON parse error in fetchToken. ', error);
          }

          if (!response) {
            response = {};
          }

          errors = responseData && responseData.errors ? responseData.errors : [];

          if (errors.length != 0) {
            console.error(errors);
            Account.clearToken();
          } else {
            const customerAccessToken = response.customerAccessToken || {};
            const accessToken = customerAccessToken.accessToken;
            const expirationDate = customerAccessToken.expiresAt;
            const payload = JSON.stringify({ token: accessToken || '', expiration: expirationDate || '' })

            if (accessToken) {
              sessionStorage.setItem(ACCESS_TOKEN_KEY, payload);
              document.dispatchEvent(tokenSetEvent);
            } else {
              Account.clearToken();
            }
          }
        }
      };
      
      xhr.send(JSON.stringify(requestBody));
    } else {
      // Notify listeners so a pending account update fails instead of hanging
      Account.clearToken();
    }
  };

  Account.clearToken = function clearToken() {
    const tokenClearedEvent = new CustomEvent(Account.TOKEN_SET_EVENT); 
    sessionStorage.setItem(ACCESS_TOKEN_KEY, '{}');
    document.dispatchEvent(tokenClearedEvent);
  };

  Account.getAccessToken = function getAccessToken() {
    const accessTokenString = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    let accessToken = '';

    if (accessTokenString) {
      try {
        accessToken = (JSON.parse(accessTokenString) || {}).token || '';
      } catch (error) {
        console.log('RS:Notification: JSON parse error in getAccessToken. ', error);
      }
    } else {
      console.log('RS:Notification: Missing token. ');
    }

    return accessToken;
  };

  Account.onLoginHandler = function onLoginHandler(e) {
    const target = e && e.target ? e.target : null;
    if (target) {
      const emailElem = target.querySelector(EMAIL_NAME_SELECTOR);
      const pwElem = target.querySelector(PW_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';
      const pw = pwElem ? pwElem.value : '';
      Account.fetchToken(email, pw);
    }
  };

  Account.registerOnLoginListener = function registerOnLoginListener() {
    const elems = document.querySelectorAll('[data-action="fetchToken"]');
    if (elems.length) {
      elems.forEach(function(elem) {
        elem.addEventListener('submit', Account.onLoginHandler);
      });
    }
  };

  Account.updateAndShowNoficiation = function updateAndShowNoficiation(form, error, isSuccess, show) {
    if (form) {
      const notificationId = form.dataset[NOTIFICATION_DATASET] || '';
      const elem = notificationId ? document.querySelector('[' + NOTIFICATION_ATTR + '="' + notificationId + '"]') : null;
      if (elem) {
        elem.innerHTML = error || '';
        applyNotificationClasses(isSuccess, elem);
        toggleHideClass(show, elem);
      }
    }
  };

  Account.toggleSubmit = function togleSubmit(form, elem, disable) {
    let submit = elem;

    if (!submit && form) {
      submit = form.querySelector(PW_RECOVER_SUBMIT_SELECTOR) || form.querySelector('[type="submit"]');
    }

    if (submit) {
      if (disable) {
        submit.setAttribute(DISABLE_ATTR, 'true');
        submit.classList.add(DISABLE_CLASS);
      } else {
        submit.removeAttribute(DISABLE_ATTR);
        submit.classList.remove(DISABLE_CLASS);
      }
    }
  };

  Account.onUpdateSuccessHandler = function onUpdateSuccessHandler(form) {
    if (form) {
      const recoverForms = document.querySelectorAll(PW_RECOVER_SELECTOR);
      const emailElem = form.querySelector(EMAIL_NAME_SELECTOR);
      const emailOrigElem = form.querySelector(EMAIL_ORIG_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';

      Account.updateAndShowNoficiation(form, 'Successfully updated customer information', true, true);
      if (email) {
        // Update original email to new email value
        if (emailOrigElem) {
          emailOrigElem.value = email;
        }

        // Update all recover form email input values to new email
        recoverForms.forEach(function(form) {
          const emailElem = form.querySelector('[name="email"]');
          if (emailElem) {
            emailElem.value = email;
          }
        });
      }
    }
  };

  Account.onUpdateErrorHandler = function onUpdateSuccessHandler(form) {
    if (form) {
      Account.updateAndShowNoficiation(
        form,
        window.theme.strings.customer.account.update_error_msg,
        false,
        true
      );
    }
  };

  Account.updateCustomer = function updateCustomer(form) {
    if (form) {
      const emailElem = form.querySelector(EMAIL_NAME_SELECTOR);
      const pwElem = form.querySelector(PW_NAME_SELECTOR);
      const emailOrigElem = form.querySelector(EMAIL_ORIG_NAME_SELECTOR);
      const firstNameElem = form.querySelector(FIRST_NAME_NAME_SELECTOR);
      const lastNameElem = form.querySelector(LAST_NAME_NAME_SELECTOR);
      const email = emailElem ? emailElem.value : '';
      const pw = pwElem ? pwElem.value : '';
      const emailOrig = emailOrigElem ? emailOrigElem.value : '';
      const firstName = firstNameElem ? firstNameElem.value : '';
      const lastName = lastNameElem ? lastNameElem.value : '';
      let accessToken = Account.getAccessToken();

      Account.toggleSubmit(form, null, true);
  
      if (!accessToken) {
        // Remove before retrying: fetchToken is synchronous and clearToken
        // dispatches this same event on failure, so retrying unconditionally
        // recurses until the stack overflows.
        const fetchTokenHandler = function() {
          document.removeEventListener(Account.TOKEN_SET_EVENT, fetchTokenHandler);
          if (Account.getAccessToken()) {
            Account.updateCustomer(form);
          } else {
            Account.onUpdateErrorHandler(form);
            Account.toggleSubmit(form, null);
          }
        };

        document.addEventListener(Account.TOKEN_SET_EVENT, fetchTokenHandler);
        Account.fetchToken(emailOrig, pw);
      } else if (firstName || lastName || email) {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", GRAPHQL_URL);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", SHOPIFY_STOREFRONT_ACCESS_TOKEN);

        const requestBody = {
          query: Account.updateCustomerQuery,
          variables: {
            "customerAccessToken": accessToken,
            "customer": {}
          }
        };

        if (firstName) {
          requestBody.variables.customer.firstName = firstName;
        }
        if (lastName) {
          requestBody.variables.customer.lastName = lastName;
        }
        if (email) {
          requestBody.variables.customer.email = email;
        }

        xhr.onreadystatechange = function() {
          if (this.readyState == 4) {
            let response = {};
            let responseData = {};
            let errors = [];
            try {
              const responseText = JSON.parse(this.responseText || '{}');
              responseData = (responseText && responseText.data ? responseText.data : {}) || {};
              response = responseData && responseData.customerAccessTokenCreate ? responseData.customerAccessTokenCreate : {};
            } catch (error) {
              console.log('RS:Notification: JSON parse error in fetchToken. ', error);
            }
  
            if (!response) {
              response = {};
            }
  
            errors = responseData && responseData.errors ? responseData.errors : [];
  
            if (errors.length != 0) {
              console.error(errors);
            } else {
              Account.onUpdateSuccessHandler(form);
            }
            Account.toggleSubmit(form, null);
          }
        };

        xhr.send(JSON.stringify(requestBody));
      }

      // Password field can be hidden and disabled once accessToken is set
      if (accessToken && pwElem) {
        const parent = pwElem.parentNode;
        if (parent) {
          parent.classList.add(HIDE_CLASS);
          pwElem.setAttribute('disabled', 'disabled');
        }
      }
    }
  };

  // Delegated from document (see setupGlobalEventDelegation) so it survives
  // Vue re-renders replacing the form element.
  Account.onAccountUpdateHandler = function onAccountUpdateHandler(e) {
    const form = e && e.target && e.target.closest ? e.target.closest(ACCOUNT_UPDATE_SELECTOR) : null;
    if (!form) return;
    e.preventDefault();
    Account.updateCustomer(form);
  };

  Account.registerAccountUpdateListener = function registerAccountUpdateListener() {
    const elems = document.querySelectorAll(ACCOUNT_UPDATE_SELECTOR);
    if (elems.length) {
      const accessToken = Account.getAccessToken();
      elems.forEach(function(elem) {
        // If access token is not set and customer is already logged in, they 
        // must enter their password. This is an additional check. The access
        // token should get set on log in.
        if (!accessToken) {
          const pwElem = elem.querySelector(PW_NAME_SELECTOR);
          const parent = pwElem ? pwElem.parentNode : null;
          if (parent) {
            parent.classList.remove(HIDE_CLASS);
            pwElem.removeAttribute('disabled');
          }
        }
      });
    }
  };

  Account.onPasswordRecoverHandler = function onUpdatePassword(e) {
    if (e && e.target) {
      e.preventDefault();
      const submit = e.target;
      const form = submit ? submit.closest(PW_RECOVER_SELECTOR) : null;
      const emailInput = form ? form.querySelector('[name="email"]') : null;
      const email = emailInput ? emailInput.value : '';
      
      if (form) {
        Account.toggleSubmit(form, submit, true);
  
        fetch(
          'https://hatheaven.com/account/recover',
          {
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: email
            })
          }
        )
        .then(function(response) {
          let errorMsg = '';
          if (response && response.ok) {
            Account.onPasswordRecoverSuccess(form);
          } else {
  
            if (response && response.status === 429) {
              errorMsg = 'Too many attempts. Please wait a few minutes and try again.';
            }
            Account.onPasswordRecoverError(form, errorMsg);
          }
        })
        .catch(function(error) {
          Account.onPasswordRecoverError(form);
        })
        .finally(function() {
          Account.toggleSubmit(form, submit);
        });
      }
    }
  };

  Account.onPasswordRecoverSuccess = function onPasswordRecoverSuccess(form) {
    const msg = `<p class="m-0">
                  Password reset instructions have been sent to your inbox.
                </pv>
                <p class="mt-2">
                  Follow the instructions in the email to reset your password. 
                </p>`;
    if (form) {
      Account.updateAndShowNoficiation(form, msg, true, true);
    }
  };

  Account.onPasswordRecoverError = function onPasswordRecoverError(form, msg) {
    if (form) {
      const errorMsg = msg || window.theme.strings.customer.account.update_error_msg;
      Account.updateAndShowNoficiation(
        form,
        errorMsg,
        false,
        true
      );
    }
  };

  Account.RegisterRecoverPasswordListener = function onUpdatePassword() {
    const elems = document.querySelectorAll(PW_RECOVER_SUBMIT_SELECTOR);
    if (elems) {
      elems.forEach(function(elem) {
        let timeout;

        // Using click instead of submit event. When using submit event, quick
        // submissions still get sent even with preventDefault called. Click 
        // events provides better control of actual form submission for this case.
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          Account.toggleSubmit(null, elem, true);
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            Account.onPasswordRecoverHandler(e);
          }, 500);
        });
      });
    }
  };
  return Account;
})();

window.theme.RS.Loader = (function() {
  const Loader = {};

  Loader.hideLoaderOnLoad = function hideLoaderOnLoad() {
    const loadWraps = document.querySelectorAll('[data-action="remove-loader-on-ready"]');
    loadWraps.forEach(function(elem) {
      const loader = elem.querySelector('[data-loader]');
      if (loader) {
        loader.classList.add('hidden');
      }
    });
  }
  return Loader;
})();

// Global event delegation setup - runs once and handles all Vue re-renders
function setupGlobalEventDelegation() {
  document.addEventListener('click', function(e) {
    const target = e.target;
    
    // Handle tab clicks
    if (target.matches('.js-customer-tab')) {
      handleTabClick(e);
    }
    
    // Handle password toggle
    if (target.matches('#passwordEyeToggle, #passwordEyeToggle *')) {
      handlePasswordToggle(e);
    }
    
    // Handle new address form toggle
    if (target.matches('.js-toggle-newaddress')) {
      handleNewAddressToggle(e);
    }
    
    // Handle edit address form toggle
    if (target.matches('.js-toggle-editaddress')) {
      handleEditAddressToggle(e);
    }
    
    // Handle footer accordion (mobile)
    if (target.matches('.js-footer-accordion, .js-footer-accordion *')) {
      handleFooterAccordionClick(e);
    }
    
    // Handle footer accordion (desktop)
    if (target.matches('#footerHeadingDesktop, #footerHeadingDesktop *')) {
      handleFooterDesktopAccordion(e);
    }
    
    // Handle skip link
    if (target.matches('.skip-link')) {
      handleSkipLinkClick(e);
    }
    
    // Handle recover password toggle
    if (target.matches('.js-toggle-recover')) {
      handleRecoverPasswordToggle(e);
    }
  });
  
  // Handle keydown events for tabs
  document.addEventListener('keydown', function(e) {
    if (e.target.matches('.js-customer-tab')) {
      handleTabKeydown(e);
    }
  });

  // Handle account update form submit
  document.addEventListener('submit', window.theme.RS.Account.onAccountUpdateHandler);
}

// Run each init step in isolation so one throwing doesn't skip the rest
function safeRun(fn) {
  try {
    fn();
  } catch (error) {
    console.log('RS:Init: error in ' + (fn.name || 'anonymous') + '. ', error);
  }
}

function init() {
  // Functions that don't add event listeners
  safeRun(generateStateSelector);
  safeRun(updateLoyaltyLionInfo);
  safeRun(removeDisabledButtonsFromFlow);
  safeRun(removeUnnecessaryOkeAttributtes);
  safeRun(showSkipToContentLink);

  // Account-related functions
  safeRun(window.theme.RS.Account.registerOnLoginListener);
  safeRun(window.theme.RS.Account.registerAccountUpdateListener);
  safeRun(window.theme.RS.Account.RegisterRecoverPasswordListener);
  safeRun(window.theme.RS.Loader.hideLoaderOnLoad);
};

// Initialize with event delegation
document.addEventListener('DOMContentLoaded', function() {
  setupGlobalEventDelegation();
  init();
});